import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";
import { setBodyBackground } from "./utils/backgroundUtils";

// Set the background image when the DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setBodyBackground);
} else {
  setBodyBackground();
}

// React 19 createRoot API
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
